import React, { useEffect } from 'react'
import Layout from '../../../components/Layout/index'
import Header from '../../../modules/Header'
import Footer from '../../../modules/Footer'
import { useIntl, navigate } from 'gatsby-plugin-intl'
import FullstackDeveloper from '../../../components/VacancyPage/FullstackDeveloper'
import messages from '../../../messages/pageTitles.lang'
import metaDescription from '../../../messages/pageMetaDescriptions.lang'
import SEO from '../../../components/seo'

const IndexPage = () => {
  const { formatMessage, locale } = useIntl()

  useEffect(() => {
    if (global.window && locale === 'de') {
      navigate('/career/')
    }
  }, [])

  return (
    <Layout footer={<Footer />} header={<Header withTeaser />}>
      <SEO
        title={formatMessage(messages.TitleFullstackDev)}
        description={formatMessage(metaDescription.fullstackDevDescription)}
        lang={locale}
        nofollow={locale === 'de'}
      />
      <FullstackDeveloper />
    </Layout>
  )
}

export default IndexPage
